import { createApi } from "@reduxjs/toolkit/query/react";

import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";

import { TRACK_ANALYTICS_EVENT } from "../../../config/apiUrlsCustomer";

import { ITrackAnalyticsEventRequest } from "../../../types/Request/CustomerRequest";

export const customerAnalyticsApi = createApi({
  reducerPath: "customerAnalyticsApi",

  baseQuery: axiosBaseQuery(),

  endpoints: (builder) => ({
    trackAnalyticsEvent: builder.mutation<void, ITrackAnalyticsEventRequest>({
      query: (data) => ({
        url: TRACK_ANALYTICS_EVENT,
        method: "post",
        data,
      }),
    }),
  }),
});

export const { useTrackAnalyticsEventMutation } = customerAnalyticsApi;
